export const employmentType = [
  "Full",
  "Part Time",
  "Casual",
  "Self-employed",
  "Unemployed",
  "Retired",
];
